import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app.module';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './settings/environment';

const platform = platformBrowserDynamic();
if (environment.production) {
    enableProdMode();
}
platform.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], }).catch(err => console.error(err));